import { Component, OnInit } from '@angular/core';
import { MDBModalRef } from 'ng-uikit-pro-standard';

@Component({
  selector: 'll-push-notification-recieved',
  templateUrl: './push-notification-recieved.component.html',
  styleUrls: ['./push-notification-recieved.component.scss']
})
export class PushNotificationRecievedComponent implements OnInit {

  constructor(public modalRef: MDBModalRef) {}

  ngOnInit(): void {
  }

}
